var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActionExportXml = function SvgActionExportXml(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9093",
    "data-name": "Group 9093",
    transform: "translate(-1245 -185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 24,
    height: 24,
    transform: "translate(1243 183)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_10",
    "data-name": "Subtraction 10",
    d: "M-1592.766-6913.119h-8.47A2.83,2.83,0,0,1-1603.9-6915h-1.1v-7.528h.941v-5.646a2.827,2.827,0,0,1,2.824-2.824h4.7l6.589,6.587v1.883h.941V-6915h-1.1A2.83,2.83,0,0,1-1592.766-6913.119Zm-10.1-1.883a1.885,1.885,0,0,0,1.63.941h8.47a1.889,1.889,0,0,0,1.63-.941Zm.162-6.211h-1.175l1.529,2.567-1.611,2.7h1.174l1.024-1.715h0l1.022,1.715h1.182l-1.619-2.709,1.529-2.561h-1.174l-.941,1.582Zm9.863,0v5.27h3.048v-.994h-2.01v-4.276Zm-2.01,1.852v3.418h1.031v-5.27h-1.069l-1.506,2.492-1.514-2.492h-1.069v5.27h1.039v-3.41l1.483,2.439h.121l1.481-2.444Zm-6.384-10.7a1.885,1.885,0,0,0-1.882,1.883v5.646h12.235v-.941h-3.765a2.825,2.825,0,0,1-2.822-2.822v-3.765Zm4.7.39v3.375a1.884,1.884,0,0,0,1.883,1.881h3.376Z",
    transform: "translate(2854.999 7120)",
    fill: "#008060"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActionExportXml, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/action-export-xml.ccdc9294.svg";
export { ForwardRef as ReactComponent };